import { cva } from 'class-variance-authority'

/**
 * Shared Tailwind className constants for patterns repeated across the app.
 * Pass these through `cn(...)` (see `@/libs/utils`) when combining with
 * additional per-usage classes.
 */

/** Label above a read-only detail value (see `JobDetails.tsx`). */
export const DETAIL_LABEL_CLASS = 'text-sm font-medium text-muted-foreground'

/** Primary value rendered under a `DETAIL_LABEL_CLASS` label. */
export const DETAIL_VALUE_CLASS = 'font-medium'

/** Secondary/helper line rendered under a `DETAIL_VALUE_CLASS` value. */
export const DETAIL_HELPER_CLASS = 'text-sm text-muted-foreground'

/** Inline spinner shown inside a submit button while a mutation is pending. */
export const BUTTON_SPINNER_CLASS = 'w-4 h-4 mr-2 animate-spin'

/**
 * Icon-only action button styling (edit/delete affordances rendered via
 * `CardActions`). Slots into the shadcn `Button` `ghost`/`icon` variant via
 * its `className` prop.
 */
export const iconActionButtonVariants = cva('', {
  variants: {
    tone: {
      default: '',
      destructive: 'text-destructive hover:text-destructive',
    },
    size: {
      default: 'h-8 w-8',
      sm: 'h-7 w-7',
    },
  },
  defaultVariants: {
    tone: 'default',
    size: 'default',
  },
})
